
function whoosh(ctx, out, t) {
  const len = ctx.sampleRate * 0.6;
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
  const src = ctx.createBufferSource();
  src.buffer = buf;
  const bp = ctx.createBiquadFilter();
  bp.type = "bandpass";
  bp.Q.value = 0.8;
  bp.frequency.setValueAtTime(300, t);
  bp.frequency.exponentialRampToValueAtTime(2600, t + 0.45);
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.35, t + 0.25);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.58);
  src.connect(bp).connect(g).connect(out);
  src.start(t);
  src.stop(t + 0.6);
}

function chime(ctx, out, t, freq, level) {
  [[1, 1], [2.76, 0.28], [5.4, 0.1]].forEach(([mult, amp]) => {
    const o = ctx.createOscillator();
    o.type = "sine";
    o.frequency.value = freq * mult;
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(level * amp, t + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 1.1 / mult + 0.25);
    o.connect(g).connect(out);
    o.start(t);
    o.stop(t + 1.4);
  });
}

function warmTone(ctx, out, t) {
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 1200;
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.22, t + 0.18);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 1.05);
  [261.63, 392.0, 523.25].forEach((f, i) => {
    const o = ctx.createOscillator();
    o.type = i === 0 ? "triangle" : "sine";
    o.frequency.value = f;
    o.detune.value = i * 3;
    o.connect(lp);
    o.start(t);
    o.stop(t + 1.1);
  });
  lp.connect(g).connect(out);
}

function render(ctx) {
  const master = ctx.createGain();
  master.gain.value = 0.25;
  master.connect(ctx.destination);
  const t = ctx.currentTime + 0.05;
  whoosh(ctx, master, t);
  chime(ctx, master, t + 0.42, 1318.5, 0.32);
  chime(ctx, master, t + 0.66, 1975.5, 0.24);
  warmTone(ctx, master, t + 0.9);
}

// Plays during the intro; if the browser blocks autoplay, plays on the first touch while the intro is showing.
export function playSonicLogo() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return () => {};
  let ctx = null;
  const events = ["pointerdown", "touchstart", "keydown"];
  const start = () => {
    ctx = new AC();
    ctx.resume().catch(() => {});
    render(ctx);
    setTimeout(() => ctx.state !== "closed" && ctx.close(), 2500);
  };
  const onGesture = () => { events.forEach((e) => window.removeEventListener(e, onGesture, true)); start(); };
  const probe = new AC();
  if (probe.state === "running") { probe.close(); start(); }
  else { probe.close(); events.forEach((e) => window.addEventListener(e, onGesture, true)); }
  return () => {
    events.forEach((e) => window.removeEventListener(e, onGesture, true));
    if (ctx && ctx.state !== "closed") ctx.close();
  };
}
